import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { tokenAtom, userAtom } from '../../../atoms/authAtoms';
import { isAuthenticated, getCurrentUser, logoutUser } from '../../../login/controller/login-controller';
import { ROUTES } from '../../../constants';
import { fetchSettings } from '../../../pages/admin/settings/controller/settings-controller';

/** Auth + scroll state shared by the storefront navbars. */
export const useStoreNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [, setUser] = useAtom(userAtom);
  const [token] = useAtom(tokenAtom);
  const navigate = useNavigate();

  useEffect(() => { setIsLoggedIn(!!token); }, [token]);
  useEffect(() => {
    const authenticated = isAuthenticated();
    setIsLoggedIn(authenticated);
    if (authenticated) setUser(getCurrentUser());
  }, [setUser]);
  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLogout = () => {
    logoutUser();
    setIsLoggedIn(false);
    setUser(null);
    navigate(ROUTES.login);
  };

  return { isMenuOpen, setIsMenuOpen, isScrolled, isLoggedIn, handleLogout };
};

/** Company contact info for storefront footers. */
export const useStoreContact = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    fetchSettings().then(setSettings).catch(() => setSettings({}));
  }, []);
  return {
    companyName: settings?.title || '',
    phone: settings?.tel ? `+216 ${settings.tel}` : '',
    email: settings?.email || '',
    facebook: settings?.lienFacebook || '',
    instagram: settings?.lienInstagram || '',
    tiktok: settings?.lienTiktok || '',
  };
};
